export default {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-shape/src/symbol/square.js
// module id = ../../../../d3-shape/src/symbol/square.js
// module chunks = 4